module.exports = __webpack_public_path__ + "img/dioxido-azufre-sulfitos.808975ed.svg";